
import { getUrl, promiseLibraries } from "./connection";
import { loading } from "./stores/loading";
import { authHeader } from "./session";
import pluralize from "pluralize";

const getLibraryData = async libraryName => {
    const librarySingular = pluralize.singular(libraryName);
    const librariesData = await promiseLibraries;
    const catalogUrl = librariesData[libraryName];
    const itemUrl = librariesData[`${librarySingular}Item`];
    const resourcesUrl = librariesData[`${librarySingular}Resources`];
    return { catalogUrl, itemUrl, resourcesUrl };
}

const fetchJson = async ({ endpoint, params = {}, customErrorString = null }) => {
    const [url,method,requestParams] = await getUrl(endpoint, params);
    const body = /get/i.test(method) ? null : JSON.stringify(requestParams);
    loading.newLoading();
    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                ...authHeader()
            },
            body
        });
        if (response.status === 200) {
            return await response.json();
        } 
        else {
            const error = new Error(customErrorString || response.statusText);
            error.status = response.status;
            throw error;
        }
    }
    catch (e) {
        throw e;
    }
    finally {
        loading.removeLoading();
    }
}

export { fetchJson, getLibraryData }
